export enum CashbackVariant {
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
}

export enum CashbackAccumulationStatus {
  /** Накопление кешбека (статус по умолчанию ) */
  ACCUMULATING,
  /** Кешбек отменен (недоступен для накопления) */
  CANCELED,
  /** Доступен для списания (прошел проверки на min/max) */
  AVAILABLE,
  /** Пользователь забрал кешбек */
  CLAIMED,
}

export interface CashbackValue {
  id: string;
  triggerId: string;
  source: string;
  userId: number;
  rewardId: string;
  cashbackVariant: CashbackVariant;
  value: number;
  currency: string;
  cashbackId: string;
  status: CashbackAccumulationStatus;
  amount: number;
  availableFrom: string;
  availableUntil: string;
  accumulatingFrom: string;
  accumulatingUntil: string;
}

export interface CashbackInfo {
  id: string;
  name: string;
  authorId: number;
  variant: CashbackVariant;
  currency: string;
  wager: number;
  wageringTerm: number;
  minCashback: Record<string, number>;
  maxCashback: Record<string, number>;
  ignoreGameIds: string[];
  ignoreProductNames: string[];
  ignoreProviderNames: string[];
  wagerGameIds: string[];
  wagerProductNames: string[];
  wagerProviderNames: string[];
  textAfterReceivingAward: string;
  textBeforeReceivingAward: string;
  hasLock: boolean;
  deletedAt?: string;
  percent: number;
}

export interface CashbackLoyaltyReward {
  id: string;
  currency: string;
  loyaltyId: string;
  rewardId: string;
  rewardType: number;
  status: string;
  updatedAt: string;
  createdAt: string;
  userId: number;
  rankIndex?: number;
  levelIndex?: number;
}

export type CashbackResponseInner = {
  cashback: CashbackInfo;
  cashbackAccumulation?: CashbackValue;
  loyaltyReward: CashbackLoyaltyReward;
};
